module.exports = __webpack_public_path__ + "f01d4d91ad315b1cc502a0731ca8e7a0.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/coh_image_2.png
// module id = 132
// module chunks = 0